import React from 'react'
import IconBase from 'react-icon-base'


export default class IconBackground extends React.Component {
  render() {
    return (
      <IconBase viewBox="0 0 20 20" {...this.props}>
        <path d="m 1.821019,10.255581 7.414535,5.020197 c 0.372277,0.25206 0.958697,0.239771 1.30985,-0.02745 L 17.539255,9.926162 C 17.89041,9.658941 17.873288,9.238006 17.501015,8.985946 L 10.08648,3.9657402 C 9.714204,3.7136802 9.127782,3.7259703 8.776627,3.9931918 L 1.782775,9.315365 c -0.3511551,0.267221 -0.3340331,0.688156 0.03824,0.940216 z" />
      </IconBase>
    )
  }
}
